import { Entity } from './forumPosts';
import { getRecord } from './universal';

export const IDENTITIES_KEY = 'IDENTITIES_KEY';

export interface Identity {
  id: number;
  followedEntities: Entity[];
}

export async function getIdentity(id: number): Promise<Identity> {
  const resp = await getRecord({
    id,
    model: 'Identity',
    attributes: ['id'],
    helpers: ['followedEntities'],
  });
  return resp.result;
}
